export const getAddressText = (location) =>
  location?.description || location?.address || location?.text || "";
